import React, { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import MenuBar from "@/components/MenuBar";
import InterviewFeed from "@/components/InterviewFeed";

const Index = () => {
  const queryClient = useQueryClient();
  
  // Force refresh of published interviews when this page loads
  useEffect(() => {
    // Refresh the published interviews
    const refreshPublishedInterviews = async () => {
      await queryClient.invalidateQueries({ queryKey: ['publishedInterviews'] });
      await queryClient.refetchQueries({ queryKey: ['publishedInterviews'] });
    };
    
    // Refresh after a short delay to ensure image updates are complete
    setTimeout(refreshPublishedInterviews, 1000);
    
    // Set up periodic refreshes
    const intervalId = setInterval(() => {
      queryClient.invalidateQueries({ queryKey: ['publishedInterviews'] });
    }, 10000);
    
    return () => clearInterval(intervalId);
  }, [queryClient]);
  
  return (
    <div className="min-h-screen bg-background">
      <MenuBar />
      <div className="max-w-4xl mx-auto px-4 pt-2 md:pt-4 pb-6">
        <InterviewFeed forceRefresh={true} />
      </div>
    </div>
  );
};

export default Index;
